import { ComponentIds, ProductUtils } from '@inter-ikea-core/core';
import { PartKey, ProductType } from '@inter-ikea-storageone/range';
/**
 * Returns the worktop of the frame assembly (or null if not found).
 */
export const getWorktop = (cabinetAssembly, coreApi) => {
    const worktops = coreApi.entities.getDescendantsWithProductType(cabinetAssembly, ProductType.KNOXHULT_WORKTOP);
    return worktops.length > 0 ? worktops[0] : null;
};
/**
 * Returns the worktop reference of the frame assembly.
 */
export const getWorktopRef = (cabinetAssembly, coreApi) => {
    const worktop = getWorktop(cabinetAssembly, coreApi);
    return worktop && ProductUtils.productRef(worktop);
};
/**
 * Returns true if the cabinet assembly has a worktop placed to the left.
 */
export const hasWorktopLeft = (cabinetAssembly, coreApi) => {
    return (getWorktop(cabinetAssembly, coreApi)?.getComponent(ComponentIds.PRODUCT_PART_COMPONENT_ID)?.partKey === PartKey.KNOXHULT_WORKTOP_LEFT);
};
/**
 * Returns true if the frame assembly has a worktop placed to the right.
 */
export const hasWorktopRight = (cabinetAssembly, coreApi) => {
    return (getWorktop(cabinetAssembly, coreApi)?.getComponent(ComponentIds.PRODUCT_PART_COMPONENT_ID)?.partKey === PartKey.KNOXHULT_WORKTOP_RIGHT);
};
/**
 * Returns true if the frame assembly has a worktop placed in the center.
 */
export const hasWorktopCenter = (cabinetAssembly, coreApi) => {
    return (getWorktop(cabinetAssembly, coreApi)?.getComponent(ComponentIds.PRODUCT_PART_COMPONENT_ID)?.partKey === PartKey.KNOXHULT_WORKTOP_CENTER);
};
//# sourceMappingURL=worktop.js.map